import React, { useCallback, useEffect, useState } from "react";
import styles from "./NavigationItem.module.scss";
import cx from "classnames";
import ItemLink from "./ItemLink";
import TabMenu from "./TabMenu";
import { CARAVAN_OWNERSHIP_TAB } from "../defaultData";
export const NavigationItem = ({ setMenuOpen, isMainMenuOpen, child = [], multiColumn, level = 1, isHeading, analytics, }) => {
    var _a, _b;
    const [open, setOpen] = useState(false);
    const [openTab, setOpenTab] = useState(0);
    const [openTabMobile, setOpenTabMobile] = useState(null);
    const resetStates = useCallback(() => {
        setMenuOpen(false);
        setOpen(false);
        setOpenTabMobile(null);
    }, [setMenuOpen]);
    useEffect(() => {
        if (!isMainMenuOpen && window.innerWidth < 1150) {
            resetStates();
        }
    }, [isMainMenuOpen, resetStates]);
    const hasSubmenuItems = Boolean(((_a = child === null || child === void 0 ? void 0 : child.submenu) === null || _a === void 0 ? void 0 : _a.length) > 0);
    const isSingleColumn = ((_b = child === null || child === void 0 ? void 0 : child.submenu) === null || _b === void 0 ? void 0 : _b.length) <= 4;
    return (<div className={cx({
            [styles.menuItem]: level === 1,
            [styles.menuItemCurtain]: child.curtainMenu || child.tabmenu,
            [styles.listItem]: level !== 1,
            [styles.menuItemWithChildren]: (hasSubmenuItems && level === 1) ||
                child.tabmenu ||
                child.curtainMenu,
            [styles.hidden]: child.disabled,
            [styles.multiColumn]: multiColumn,
            [styles.heading]: isHeading,
        })}>
      {!child.url ? (<span className={styles.disabledLinkItem}>{child.name}</span>) : (<ItemLink child={child} className={styles.linkItem} resetStates={resetStates}/>)}
      {hasSubmenuItems && (<>
          <button onClick={() => setOpen(true)} className={styles.mobileOpenButton}/>
          <div className={cx(styles.list, "flexOnHover", {
                [styles.mobileOpen]: open,
                [styles.singleColumn]: isSingleColumn,
            })}>
            <button onClick={() => setOpen(false)} className={styles.mobileCloseButton}>
              Back
            </button>
            <div className={`${styles.listItem} ${styles.mobileOnly}`}>
              {!child.url ? (<span className={styles.disabledLinkItem}>{child.name}</span>) : (<ItemLink child={child} className={styles.linkItem} resetStates={resetStates}/>)}
            </div>
            {child.submenu.map((item) => (<NavigationItem key={`${child.name}_${item.name}`} child={item} level={level + 1} multiColumn={!isSingleColumn} setMenuOpen={setMenuOpen} isHeading={item.heading} isMainMenuOpen={isMainMenuOpen}/>))}
          </div>
        </>)}
      {child.curtainMenu && (<>
          <button onClick={() => setOpen(true)} className={styles.mobileOpenButton}>
            Open
          </button>
          <div className={cx(styles.list, styles.curtain, "flexOnHover", {
                [styles.mobileOpen]: open,
                [styles.singleColumn]: isSingleColumn,
            })}>
            <button onClick={() => setOpen(false)} className={styles.mobileBackButton}>
              Back
            </button>
            <div className={styles.curtainMenu}>
              {child.curtainMenu.map((item, index) => (<React.Fragment key={`${child.name}_${index}`}>
                  <div className={cx(styles.column, index === 0 && !item.name && styles.noHeading)}>
                    {item.name ? (<span className={styles.listHeading}>{item.name}</span>) : null}
                    <div className={styles.columnLinks}>
                      {item.submenu.map((item) => (<ItemLink key={item.name} child={item} className={styles.listItem} resetStates={resetStates}/>))}
                    </div>
                  </div>
                </React.Fragment>))}
            </div>
            {child.name === CARAVAN_OWNERSHIP_TAB ? (<div className={styles.curtainFooter}>
                Ownership enquiries
                <a onClick={() => analytics === null || analytics === void 0 ? void 0 : analytics({
                    event: "visitor interaction",
                    interactionName: "click to call",
                    phoneNumber: "03332021460",
                })} href="tel:03332021460" className={styles.footerLink}>
                  0333 202 1460
                </a>
              </div>) : null}
          </div>
        </>)}
      {child.tabmenu && (<TabMenu open={open} child={child} resetStates={resetStates} setOpen={setOpen} setOpenTab={setOpenTab} setOpenTabMobile={setOpenTabMobile} openTab={openTab} openTabMobile={openTabMobile}/>)}
    </div>);
};
